import React from 'react';
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { formatNumber } from '@progress/kendo-intl';

export default class CodeTableRow extends React.Component {

    handleCodeUnitsChange = (e) => {
        this.props.onCodeUnitsChange(this.props.code, e.target.value);
    }

    handleCodeDelete = (e) => {
        e.preventDefault();
        this.props.onCodeDelete(this.props.index);
    }

    render() {
        return (
            <tr className={this.props.parent ? 'admin-code' : ''} data-allowables={this.props.allowables} data-wrvu={this.props.wrvu}>
                <td><div>{this.props.code}</div></td>
                <td>{this.props.name}</td>
                <td>
                    <NumericTextBox
                        spinners={false}
                        min={0}
                        maxLength={6}
                        format="#"
                        value={this.props.units}
                        onChange={this.handleCodeUnitsChange}
                    />
                </td>
                <td>{formatNumber(this.props.units * this.props.cost, '$0.00')}</td>
                <td><button type="button" className="btn btn-secondary" onClick={this.handleCodeDelete}>DELETE</button></td>
            </tr>
        );
    }
}